import { Auth, CognitoUser } from '@aws-amplify/auth';
import {
  abandonMerge,
  reloadApp,
  settleMergeSignIn,
} from '@/utils/identityClaimSession';

export const GENERIC_ERROR_MESSAGE = 'Ocurrió un error. Intentá de nuevo.';
const WRONG_CREDENTIALS_MESSAGE = 'El usuario o la clave no son correctos.';
const CHALLENGE_MESSAGE =
  'Ese usuario tiene que terminar de entrar por su cuenta. Entrá con él, cerrá la sesión y volvé a intentarlo.';

/** The merge carries this session's access token, so it starts with a fresh one. */
export const refreshCurrentSession = async (): Promise<void> => {
  const user: CognitoUser = await Auth.currentAuthenticatedUser();
  const session = await Auth.currentSession();
  await new Promise<void>((resolve, reject) =>
    user.refreshSession(session.getRefreshToken(), (error) =>
      error ? reject(error) : resolve()
    )
  );
};

const signInErrorMessage = (error: unknown): string => {
  const code = (error as { code?: string } | null)?.code;
  if (code === 'NotAuthorizedException' || code === 'UserNotFoundException')
    return WRONG_CREDENTIALS_MESSAGE;
  return GENERIC_ERROR_MESSAGE;
};

/**
 * Signs in with the missing session of a merge already begun. Reloads on
 * success; otherwise drops the merge and returns what to show.
 */
export const signInForMerge = async (
  username: string,
  password: string,
  sameUserMessage: string
): Promise<string | null> => {
  try {
    const signedIn = await Auth.signIn(username, password);
    if (signedIn?.challengeName) {
      abandonMerge();
      return CHALLENGE_MESSAGE;
    }
    if (settleMergeSignIn()) {
      reloadApp();
      return null;
    }
    abandonMerge();
    return sameUserMessage;
  } catch (error) {
    abandonMerge();
    return signInErrorMessage(error);
  }
};
